import styled from 'styled-components'

const CaptchaContentUi = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export default CaptchaContentUi
